import { ImageService } from './../../services/image/image.service'
import { SettingsService } from '../../services/settings/settings.service'
import { AlertService } from '../../services/alert/alert.service'
import { UserService, IUser } from 'src/app/services/user/user.service'
import { Component, OnInit, OnDestroy } from '@angular/core'
import { NavController } from '@ionic/angular'

@Component({
  selector: 'app-profile',
  templateUrl: './profile.page.html',
  styleUrls: ['./profile.page.scss'],
})
export class ProfilePage implements OnInit, OnDestroy {

  user: IUser
  userSubscription: any
  serverUrl: string

  deleteOldDataValue = false

  allowMailNotifications = false
  allowPushNotifications = false

  constructor(
    private navCtrl: NavController,
    private userService: UserService,
    private alert: AlertService,
    private settingsService: SettingsService,
    private imgService: ImageService
  ) {
    this.serverUrl = this.settingsService.serverUrl
    this.deleteOldDataValue = this.settingsService.deleteOldDataValue
  }

  ngOnInit() {
    this.userSubscription = this.userService.currentUser.subscribe(value => {
      this.user = value
      if (value) {
        this.allowMailNotifications = value.allowMailNotifications
        this.allowPushNotifications = value.allowPushNotifications
      }
    })
  }

  ngOnDestroy() {
    this.userSubscription.unsubscribe()
  }

  ionViewWillLeave() {
    this.imgService.cleanup()
  }

  logout() {
    return new Promise((resolve, reject) => {
      if (this.user.deviceToken)
        this.userService.setDeviceToken(this.user.token, this.user.deviceToken, true)
          .then(() => resolve())
          .catch((err) => {
            this.alert.errorHandlerPrompt(
              err,
              'Abmelldung vom Server fehlgeschlagen. Stelle sicher, dass Dein Gerät mit dem Internet verbunden ist!')
            return reject()
          })
      else
        resolve()
    })
      .then(() => this.userService.logout())
      .then(() => this.imgService.clearCache(false))
      .then(() => this.navCtrl.navigateRoot('/login', { animationDirection: 'forward' }))
      .catch((err) => this.alert.errorHandler(err))
  }

  saveServerUrl() {
    this.alert.confirmPrompt('Bist Du sicher, dass Du die Serveradresse ändern möchtest?', 'Warnung')
      .then(result => {
        if (result)
          return this.settingsService.setServerUrl(this.serverUrl)
            .then(() => this.navCtrl.pop())
      })
      .catch((err) => this.alert.errorHandler(err))
  }

  gotoGroup() {
    this.navCtrl.navigateForward('/group')
  }

  gotoChangepw() {
    this.navCtrl.navigateForward('/changepw')
  }

  clearCache() {
    this.imgService.clearCache(this.userService.isLoggedin)
      .then(() => this.alert.toast('Cache erfolgreich geleert'))
      .catch((err) => this.alert.errorHandler(err, 'Ein Fehler beim Leeren von Cache ist aufgetreten!'))
  }

  setBackgroundImage() {
    this.imgService.getImageFromDevice()
      .then((img: string) => this.imgService.saveAppBackground(img))
      .then(() => this.alert.toast('Hintergrundbild erfolgreich geändert'))
      .catch((err) => this.alert.errorHandler(err, true))
  }

  /* setBackgroundImage() {
    // needed for browser version!
    const obs = new MutationObserver(() => {
      const addedElements = document.getElementsByName('files[]')
      for (let i = addedElements.length - 1; i >= 0; i--) {
        addedElements[i].setAttribute('style', 'z-index: -1;')
        addedElements[i].setAttribute('accept', 'image/jpeg')
      }

      const input = document.getElementsByName('files[]')[0] as HTMLElement
      if (typeof input !== 'undefined')
        input.click()
    })
    obs.observe(document.body, { childList: true })
    setTimeout(() => {
      obs.disconnect()
    }, 1000)
    // ---

    this.imgService.getPictureFromDevice()
      .then((path: string) => {
        // console.log('resolved path: ', path)
        if (typeof path !== 'undefined')
          return this.imgService.saveAppBackground(path)
            .then(() => this.alert.toast('Hintergrundbild erfolgreich geändert'))
      })
      .catch((err) => this.alert.errorHandler(err, true))
  } */

  setDeleteOldDataValue() {
    this.settingsService.setDeleteOldDataValue(this.deleteOldDataValue)
      .catch((err) => this.alert.errorHandler(err, true))
  }

  setNotificationsValues(type: 'mail' | 'push') {
    if (type === 'mail')
      this.allowMailNotifications = !this.allowMailNotifications
    else if (type === 'push')
      this.allowPushNotifications = !this.allowPushNotifications

    this.userService.setNotificationsValues(
      this.user.token,
      type === 'mail' ? this.allowMailNotifications : undefined,
      type === 'push' ? this.allowPushNotifications : undefined,
    )
      .catch((err) => this.alert.errorHandler(err, true))
  }

  gotoHowTo() {
    this.navCtrl.navigateForward('/howto')
  }
}
